import { Button, Checkbox, Form, Input, Modal } from 'antd';
import React, {useContext, useEffect, useState} from 'react';
import "./AppMenu.css"
import { UserContext } from '../../contexts/UserContext';
import { handleResponse } from '../../helpers';
import { reverseGeocoding } from '../../services';
import bicycle from "./Images/bicikl_ikona_v2.png";
import scooter from "./Images/romobil_ikona.png";
import klamerica from "./Images/obrnuti_u_ikona.png"

const AppMenu = ({onEnterSupply, onEnterDemand, onLocate,showDemandButton,onManualLocate, ...props}) => {
    const {location, setLocation} = useContext(UserContext)

    useEffect(() => {
        
        const fetchData = async () => {
            const hasPermission = await navigator?.permissions?.query({name:'geolocation'}) || false
            if(hasPermission.state == "granted") {
                if(!location) {
                    navigator.geolocation.getCurrentPosition(async position => {
                        const addressInfo = await reverseGeocoding(position.coords.latitude, position.coords.longitude) 
                        if(addressInfo?.address) {
                            setLocation({coords: position.coords, ...addressInfo?.address, display_name: addressInfo?.display_name})
                        }
                    }, null, {enableHighAccuracy: true, timeout: 20000, maximumAge: 100000})
                }
            }
           
        }
        fetchData()
    }, [])


    return (
    <>
        <div className="app-menu">
            <div className="app-menu__locate" onClick={onLocate}>
                <div className="app-menu__position"><i className="ri-compass-discover-line"></i></div>
                <div className="app-menu__address-info">
                    <div className="app-menu__address">{location?.road || location?.village || 'Omogućite nam pristup svojoj lokaciji,'}</div>
                    <div className="app-menu__description">{location && `${location.city || location.hamlet || location.county}${location?.country && ", " || ''}${location?.country}` || 'kako biste mogli prijaviti parkirališnu ponudu/potražnju'}</div>
                </div> 
                
            </div>
            {location &&<div className="app-menu__locate app-menu__locate-manual " onClick={onManualLocate}>                
                <div className="app-menu__position-manual"><i className="ri-map-pin-fill"></i></div>  
                <p className='app-menu__location-text app-menu__location-text-manual'>Ručno pozicioniranje</p>                
            </div>
                }
            <div className="app-menu__options">
                <Button size="large" onClick={onEnterSupply}>
                    <img src={klamerica} style={{width:"45px",marginRight:"15px"}}></img>
                    Unos ponude
                </Button>
                {showDemandButton&&(
                <>
                <div className="app-menu__separator"></div>
               <Button size="large" onClick={onEnterDemand}>
                    <img src={bicycle} style={{width:"50px",marginRight:"8px"}}></img>
                    Unos potražnje
                </Button>
                </>
                )}
            </div>
        </div>

       
     </>
    );
};

export default AppMenu;